import { render } from "./PartnersForm.vue?vue&type=template&id=54213b49&scoped=true"
import script from "./PartnersForm.vue?vue&type=script&lang=js"
export * from "./PartnersForm.vue?vue&type=script&lang=js"

import "./PartnersForm.vue?vue&type=style&index=0&id=54213b49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54213b49"]])

export default __exports__